import { useEffect, useState } from 'react'
import ReactDOM from "react-dom";
import { useDispatch, useSelector } from 'react-redux'

import OutsideClickComponent from '../../../fragments/OutsideClickComponent'
import Card from '../../../common/Card'
import Button from '../../../common/Button'
import ControlsDelete from './ControlsDelete'
import { notificationActions } from '../../../../store/notifications'
import { caseQuickUpdate } from '../../../../lib/fetchApi'
import { caseActions } from '../../../../store/case'
import Modal from '../../../common/Modal';
import ModalInnerWrapper from '../../../common/ModalInnerWrapper';
import CreateLawFirmLocationForm from '../forms/CreateLawFirmLocationForm';
import CreateLawFirmLAttorneyForm from '../forms/CreateLawFirmAttorneyForm';
import CreateLawFirmCaseManagerForm from '../forms/CreateLawFirmCaseManagerForm';
import GeneralCreateLocationForm from '../forms/GeneralCreateLocationForm';
import GeneralCreateAdjusterForm from '../forms/GeneralCreateAdjusterForm';
import GeneralCreateNurseForm from '../forms/GeneralCreateNurseForm';
import { isCaseArchived, useUserTabEditPermissionDisabled } from '../../../../lib/usersPermissions';

import classes from './Group.module.css'
import Backdrop from '../../../common/modal/Backdrop';

const GroupControls = ({folder, groupData, groupDataID, fieldsData, apiCase}) => {
    let userPermissionDisabled = useUserTabEditPermissionDisabled(apiCase)

    let fieldDataGroup = (fieldsData.group.includes('_') && fieldsData.group != 'case_managers') ? fieldsData.group.split('_')[1] + 's' : fieldsData.group

    let createField = apiCase == 'case_attorney' ? 'law_firm_create_' + fieldDataGroup : 'insurance_carrier_create_' + fieldDataGroup  
    
    let entityCreatePermissions = useUserTabEditPermissionDisabled(createField)

    let editField = apiCase == 'case_attorney' ? 'law_firm_edit_' + fieldDataGroup : 'insurance_carrier_edit_' + fieldDataGroup
    let entityEditPermissions = useUserTabEditPermissionDisabled(editField)

    const dispatch = useDispatch()
    const [controlsOpened, setControlsopened] = useState(false)
    const [modalOpned, setModalOpened] = useState(false)
    const [modalCreateOpned, setModalCreateOpened] = useState(false)
    const [componentData, setComponentData] = useState(null)

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)

    const showModal = () => {
        if (!isCaseArchived(activeCase?.case?.master_status_id) && !userPermissionDisabled) { // disable actions with the global disable
            setControlsopened(prevState => prevState = !prevState)
        }
        
    }

    const openModalHandler = () => {
        setModalOpened(true)
        setControlsopened(false)
    }

    const closeModalHandler = () => {
        setModalOpened(false)
    }

    const openModalCreateHandler = () => {
        setModalCreateOpened(true)
        setControlsopened(false)
    }

    const closeModalCreateHandler = () => {
        setModalCreateOpened(false)
    }

    const deleteitem = async () => {
        let f = []
        fieldsData.fields.forEach(element => {
            f.push({
                field: element,
                value: null
            })
        });
        let body = {
            folder: folder,
            item: {
                itemId: groupData.id,
                fields: f                
            },
        }
   
        if (folder != 'worker_comp') {
            setTimeout(() => {
                dispatch(caseActions.modifyActiveCaseMultiple(body))
            }, 0)
        } else {
            let dispatchObj = {
                folder: folder,
                item: {
                    fields: f           
                }
            }
            setTimeout(() => {
                dispatch(caseActions.modifyActiveCaseMultipleObject(dispatchObj))
            }, 0)
        }
        

        let reqBody = {
            type: apiCase,
            type_id: groupData.id,
            fields: {
                [fieldsData.fieldId] : null,
            }
        }
        setControlsopened(false)
        const update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        } 
        
    }


    useEffect(() => {
        if (activeCase) {
            if (folder != 'worker_comp') {
                let item = activeCase[folder].find(item => item.id == groupDataID)
                setComponentData(item)
            } else {
                let item = activeCase[folder]
                setComponentData(item)
            }
        }
    }, [activeCase, groupDataID, folder])

    return <div className={classes.controls_container}>
        <button onClick={showModal}>
            <i className="ti ti-dots-vertical"></i>
            <span className="sr-only">open item menu</span>
        </button>
        
        {controlsOpened && <OutsideClickComponent task={showModal}>
            <div className={classes.controls_window}>
                <Card>
                    <ul>
                        {groupData[fieldsData.fieldId] && <li><ControlsDelete action={deleteitem}/></li>}
                        {entityEditPermissions && groupData[fieldsData.fieldId] && <li>
                            <Button click={openModalHandler} btnStyle={'btn_simple'}><i className='ti ti-edit'></i>Edit Item</Button>
                        </li>}                       
                        {entityCreatePermissions && <li>
                            <Button click={openModalCreateHandler} btnStyle={'btn_simple'}><i className="ti ti-square-plus"></i>Create</Button>
                        </li>}
                    </ul>
                </Card>
            </div>    
        </OutsideClickComponent>}

        {modalOpned && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeModalHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    {folder == 'attorneys' && <>
                        {fieldsData.fieldId && fieldsData.fieldId == 'location_id' && <ModalInnerWrapper closeModal={closeModalHandler} modalTitle={'Edit Location'}>
                            <CreateLawFirmLocationForm closeModal={closeModalHandler} firmData={componentData} edit={true} />
                        </ModalInnerWrapper>}
                        {fieldsData.fieldId && fieldsData.fieldId == 'attorney_id' && <ModalInnerWrapper closeModal={closeModalHandler} modalTitle={'Edit Attorney'}>
                            <CreateLawFirmLAttorneyForm closeModal={closeModalHandler} firmData={componentData} edit={true} />
                        </ModalInnerWrapper>}                    
                        {fieldsData.fieldId && fieldsData.fieldId == 'case_manager_id' && <ModalInnerWrapper closeModal={closeModalHandler} modalTitle={'Edit Case Manager'}>
                            <CreateLawFirmCaseManagerForm closeModal={closeModalHandler} firmData={componentData} edit={true}/>
                        </ModalInnerWrapper>}
                    </>}
                    {folder !== 'attorneys' && <>
                        {fieldsData.fieldId && fieldsData.fieldId == 'location_id' && <ModalInnerWrapper closeModal={closeModalHandler} modalTitle={'Edit Location'}>
                            <GeneralCreateLocationForm closeModal={closeModalHandler} itemData={componentData} folder={folder} apiCase={apiCase} edit={true}/>
                        </ModalInnerWrapper>}

                        {fieldsData.fieldId && fieldsData.fieldId == 'mp_adjuster_id' && <ModalInnerWrapper closeModal={closeModalHandler} modalTitle={'Edit Adjuster'}>
                            <GeneralCreateAdjusterForm closeModal={closeModalHandler} itemData={componentData} folder={folder} apiCase={apiCase} fieldsData={fieldsData} edit={true}/>
                        </ModalInnerWrapper>}

                        {fieldsData.fieldId && fieldsData.fieldId == 'um_adjuster_id' && <ModalInnerWrapper closeModal={closeModalHandler} modalTitle={'Edit Adjuster'}>
                            <GeneralCreateAdjusterForm closeModal={closeModalHandler} itemData={componentData} folder={folder} apiCase={apiCase} fieldsData={fieldsData} edit={true}/>
                        </ModalInnerWrapper>}

                        {fieldsData.fieldId && fieldsData.fieldId == 'adjuster_id' && <ModalInnerWrapper closeModal={closeModalHandler} modalTitle={'Edit Adjuster'}>
                            <GeneralCreateAdjusterForm closeModal={closeModalHandler} itemData={componentData} folder={folder} apiCase={apiCase} fieldsData={fieldsData} edit={true}/>
                        </ModalInnerWrapper>}

                        {fieldsData.fieldId && fieldsData.fieldId == 'nurse_id' && <ModalInnerWrapper closeModal={closeModalHandler} modalTitle={'Edit Nurse'}>
                            <GeneralCreateNurseForm closeModal={closeModalHandler} itemData={componentData} folder={folder} apiCase={apiCase} fieldsData={fieldsData} edit={true}/>
                        </ModalInnerWrapper>}
                    </>}  
                    
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}


        {modalCreateOpned && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeModalCreateHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    {folder == 'attorneys' && <>
                        {fieldsData.fieldId && fieldsData.fieldId == 'attorney_id' && <ModalInnerWrapper closeModal={closeModalCreateHandler} modalTitle={'Create Attorney'}>
                            <CreateLawFirmLAttorneyForm closeModal={closeModalCreateHandler} firmData={componentData} />
                        </ModalInnerWrapper>}
                        {fieldsData.fieldId && fieldsData.fieldId == 'location_id' && <ModalInnerWrapper closeModal={closeModalCreateHandler} modalTitle={'Create Location'}>
                            <CreateLawFirmLocationForm closeModal={closeModalCreateHandler} firmData={componentData} />
                        </ModalInnerWrapper>}
                        {fieldsData.fieldId && fieldsData.fieldId == 'case_manager_id' && <ModalInnerWrapper closeModal={closeModalCreateHandler} modalTitle={'Create Case Manager'}>
                            <CreateLawFirmCaseManagerForm closeModal={closeModalCreateHandler} firmData={componentData} />
                        </ModalInnerWrapper>}
                    </>}

                    {folder !== 'attorneys' && <>
                        {fieldsData.fieldId && fieldsData.fieldId == 'location_id' && <ModalInnerWrapper closeModal={closeModalCreateHandler} modalTitle={'Create Location'}>
                            <GeneralCreateLocationForm closeModal={closeModalCreateHandler} itemData={componentData} folder={folder} apiCase={apiCase}/>
                        </ModalInnerWrapper>}

                        {fieldsData.fieldId && fieldsData.fieldId == 'mp_adjuster_id' && <ModalInnerWrapper closeModal={closeModalCreateHandler} modalTitle={'Create Adjuster'}>
                            <GeneralCreateAdjusterForm closeModal={closeModalCreateHandler} itemData={componentData} folder={folder} apiCase={apiCase} fieldsData={fieldsData}/>
                        </ModalInnerWrapper>}

                        {fieldsData.fieldId && fieldsData.fieldId == 'um_adjuster_id' && <ModalInnerWrapper closeModal={closeModalCreateHandler} modalTitle={'Create Adjuster'}>
                            <GeneralCreateAdjusterForm closeModal={closeModalCreateHandler} itemData={componentData} folder={folder} apiCase={apiCase} fieldsData={fieldsData}/>
                        </ModalInnerWrapper>}

                        {fieldsData.fieldId && fieldsData.fieldId == 'adjuster_id' && <ModalInnerWrapper closeModal={closeModalCreateHandler} modalTitle={'Create Adjuster'}>
                            <GeneralCreateAdjusterForm closeModal={closeModalCreateHandler} itemData={componentData} folder={folder} apiCase={apiCase} fieldsData={fieldsData}/>
                        </ModalInnerWrapper>}

                        {fieldsData.fieldId && fieldsData.fieldId == 'nurse_id' && <ModalInnerWrapper closeModal={closeModalCreateHandler} modalTitle={'Create Nurse'}>
                            <GeneralCreateNurseForm closeModal={closeModalCreateHandler} itemData={componentData} folder={folder} apiCase={apiCase} fieldsData={fieldsData}/>
                        </ModalInnerWrapper>}
                    </>}   
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    </div>
}

export default GroupControls